package com.hyperether.goodjob.scenes.components.drawer

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.BottomNavigation
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.material.Text
import androidx.compose.material3.DrawerState
import androidx.compose.material3.ModalDrawerSheet
import androidx.compose.material3.ModalNavigationDrawer
import androidx.compose.material3.NavigationDrawerItem
import androidx.compose.material3.NavigationDrawerItemDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.navigation.NavHostController
import com.hyperether.goodjob.CommonModule
import com.hyperether.goodjob.navigation.AndroidNav
import com.hyperether.goodjob.navigation.NavGraph
import com.hyperether.goodjob.navigation.ProfileSettings
import com.hyperether.goodjob.navigation.Pricing
import com.hyperether.goodjob.navigation.RouteScreen
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.no_information
import com.hyperether.goodjob.scenes.components.CircleWithInitialUser
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource

@Composable
fun DrawerComponent(
    modifier: Modifier = Modifier,
    navController: NavHostController,
    commonModule: CommonModule,
    onChoosePlanClick: (Double, String) -> Unit,
    startRoute: RouteScreen,
    isBottomNavigationBarVisible: Boolean,
    onLogout: () -> Unit,
    onUploadDocumentClick: (String, DocumentType) -> Unit,
    onOpenPdf: (String) -> Unit,
    drawerState: DrawerState
) {

    val drawerItems = getDrawerItems(commonModule.repository)

    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        val scope = rememberCoroutineScope()
        var selectedItemIndex by rememberSaveable {
            mutableIntStateOf(-1)
        }
        ModalNavigationDrawer(
            drawerContent = {
                ModalDrawerSheet(
                    modifier = Modifier.width(300.toScaleDp()),
                    drawerContainerColor = Color.White
                ) {
                    Column(modifier = modifier.fillMaxHeight().padding(8.toScaleDp())) {
                        Column(
                            verticalArrangement = Arrangement.SpaceBetween
                        ) {
                            Spacer(modifier = Modifier.height(30.toScaleDp()))
                            NavigationDrawerItem(
                                modifier = Modifier.fillMaxWidth(),
                                label = {
                                    Text(
                                        text = drawerItems[0].title,
                                        fontWeight = FontWeight.ExtraBold,
                                        fontSize = 18.toScaleSp(),
                                        color = Color.Black,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis,
                                        modifier = Modifier.offset(y = (-7).toScaleDp())
                                    )
                                },
                                selected = 0 == selectedItemIndex,
                                onClick = {
                                    selectedItemIndex = 0
                                },
                                icon = {
//                                Image(
//                                    painter = painterResource(drawerItems[0].painter),
//                                    modifier = Modifier.size(Dp(30f)),
//                                    contentDescription = drawerItems[0].title
//                                )
                                    CircleWithInitialUser(
                                        commonModule.prefsManager.getUser(),
                                        size = 48.toScaleDp()
                                    )
                                },
                                colors = NavigationDrawerItemDefaults.colors(
                                    selectedContainerColor = Color.Transparent,
                                    selectedBadgeColor = Color.Transparent,
                                )
                            )
                            Text(
                                text = commonModule.userViewModel.roleMap.entries.find { entry -> entry.value == commonModule.prefsManager.getUser()?.role }?.key
                                    ?: stringResource(
                                        Res.string.no_information
                                    ),
                                fontWeight = FontWeight.Normal,
                                fontSize = 14.toScaleSp(),
                                color = Color.LightGray,
                                modifier = Modifier.padding(start = 78.toScaleDp())
                                    .offset(y = (-28).toScaleDp())
                            )
                        }
                        androidx.compose.material.Divider(
                            color = BorderColor,
                            thickness = 1.toScaleDp()
                        )
                        for (index in 1 until drawerItems.size - 1) {
                            NavigationDrawerItem(
                                label = {
                                    Text(text = drawerItems[index].title, color = TextColor)
                                },
                                selected = index == selectedItemIndex,
                                onClick = {
                                    selectedItemIndex = index
                                    scope.launch {
                                        drawerState.close()
                                    }
                                    when (index) {
                                        1 -> {
                                            navController.navigate(ProfileSettings)
                                        }

                                        2 -> {
                                            commonModule.pricingViewModel.setNavigationFromDrawer(
                                                true
                                            )
                                            navController.navigate(Pricing)
                                        }

                                        3 -> {}
                                        4 -> {}
                                    }
                                },
                                icon = {
                                    Image(
                                        painter = painterResource(drawerItems[index].painter),
                                        modifier = Modifier.size(30.toScaleDp()),
                                        contentDescription = drawerItems[index].title,
                                    )
                                },
                                modifier = Modifier.fillMaxWidth().height(70.toScaleDp()),
                                colors = NavigationDrawerItemDefaults.colors(
                                    selectedContainerColor = Color.Transparent,
                                    selectedBadgeColor = Color.Transparent,
                                )
                            )
                            androidx.compose.material.Divider(
                                color = BorderColor,
                                thickness = 1.toScaleDp()
                            )
                        }
                        Spacer(modifier = Modifier.weight(1f))

                        NavigationDrawerItem(
                            label = {
                                Text(
                                    text = drawerItems[drawerItems.size - 1].title,
                                    color = Color.Red
                                )
                            },
                            selected = ((drawerItems.size - 1) == selectedItemIndex),
                            onClick = {
                                selectedItemIndex = drawerItems.size - 1
                                scope.launch {
                                    drawerState.close()
                                }
                                onLogout()
                            },
                            icon = {
                                Image(
                                    painter = painterResource(drawerItems[drawerItems.size - 1].painter),
                                    modifier = Modifier.size(30.toScaleDp()),
                                    contentDescription = drawerItems[drawerItems.size - 1].title,
                                    //tint = if (index == 6) Color.Red else TextColor
                                )
                            },
                            modifier = Modifier.fillMaxWidth().padding(bottom = 30.toScaleDp()),
                            colors = NavigationDrawerItemDefaults.colors(
                                selectedContainerColor = Color.Transparent,
                                selectedBadgeColor = Color.Transparent,
                            )
                        )
                    }
                }
            },
            drawerState = drawerState,
            gesturesEnabled = drawerState.isOpen
        ) {
            Column {
                NavGraph(
                    navController,
                    commonModule,
                    modifier = Modifier.weight(1f),
                    currentRoute = startRoute,
                    onChoosePlanClick = onChoosePlanClick,
                    drawerState = drawerState,
                    onUploadDocumentClick = onUploadDocumentClick,
                    onOpenPdf = onOpenPdf
                )
                if (isBottomNavigationBarVisible) {
                    BottomNavigation(backgroundColor = Color.White) {
                        AndroidNav(navController, commonModule.prefsManager)
                    }
                }
            }

        }
//        if (showProgressBar.value) {
//            FullScreenProgressBar(showProgressBar = viewModel.showProgressBar)
//        }
    }
}